(function () {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('[data-reveal],[data-reveal-clip]').forEach(function (el) { el.classList.add('aj-in'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        var d = parseInt(e.target.getAttribute('data-delay') || '0', 10);
        setTimeout(function () { e.target.classList.add('aj-in'); }, d);
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.16, rootMargin: '0px 0px -8% 0px' });
  document.querySelectorAll('[data-reveal],[data-reveal-clip]').forEach(function (el) { io.observe(el); });
  var par = document.querySelector('[data-parallax]');
  var nav = document.getElementById('ajnav');
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var y = window.scrollY || 0;
      if (par) par.style.transform = 'translateY(' + Math.min(y * 0.12, 140) + 'px)';
      if (nav) nav.style.paddingBlock = y > 40 ? '12px' : '22px';
      ticking = false;
    });
  }, { passive: true });
})();
